'use client';

import { type ReactNode } from 'react';
import { type LogParameters } from '../models';
import { usePageLogger } from '../hooks/usePageLogger';
import { ImpressionArea } from '../../react/ImpressionArea';
interface BaseProps {
  areaThreshold?: number;
  timeThreshold?: number;
  disableLoggingOnce?: boolean;
  children: ReactNode;
  params?: LogParameters;
  className?: string;
}
interface OnlyImpressionProps extends BaseProps {
  logName: string;
  impressionLogName?: never;
  unimpressionLogName?: never;
}
interface ImpressionStartAndEndProps extends BaseProps {
  logName?: never;
  impressionLogName: string;
  unimpressionLogName: string;
}
export const LoggingImpression = ({
  children,
  impressionLogName,
  unimpressionLogName,
  logName,
  areaThreshold,
  timeThreshold,
  disableLoggingOnce = false,
  params,
  className
}: OnlyImpressionProps | ImpressionStartAndEndProps) => {
  const pageLogger = usePageLogger();
  if (impressionLogName == null) {
    return <ImpressionArea areaThreshold={areaThreshold} className={className} timeThreshold={timeThreshold} impressionOnce={!disableLoggingOnce} onImpressionStart={() => {
      pageLogger?.impressed(logName, params);
    }}>
        {children}
      </ImpressionArea>;
  }
  return <ImpressionArea areaThreshold={areaThreshold} className={className} timeThreshold={timeThreshold} impressionOnce={!disableLoggingOnce} onImpressionEnd={() => {
    pageLogger?.unimpressed(unimpressionLogName, params);
  }} onImpressionStart={() => {
    pageLogger?.impressed(impressionLogName, params);
  }} data-sentry-element="ImpressionArea" data-sentry-component="LoggingImpression" data-sentry-source-file="LoggingImpression.tsx">
      {children}
    </ImpressionArea>;
};